// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"2cc30685","93":"2cc30685","670":"70913969","772":"5d021653"}[chunkId] + ".chunk.css";
};